import { Accordion, AccordionTab } from 'primereact/accordion';
import React from 'react';
import { connect } from 'react-redux';
import { Alert, Loader } from '../../../../components';
import * as Forms from '../../../../components/forms';
import { IDataStorage } from '../../../../core';
import Translate from '../../../../core/translate';
import API from '../../../../services/api';
import { IContacto } from '../../../../services/api/entity/model/IContacto';
import Common, { FormService } from '../../../../services/common';
import { IResponse } from '../../../../services/model';

interface IProps {
  storage?: IDataStorage;
  refService?: (form:FormService<IContacto>) => void;

  //codigo?: number;
  readonly?: boolean;
  id?: number;
  hideCodigo?: boolean;
  hideCliente?: boolean;

  forceTipo?: string;

  entity?: () => IContacto | undefined; // opcionalmente se recibe el objeto a editar
}

interface IState {
  storage?: IDataStorage;

  //codigo?: number;
  id?: number,
  readonly?: boolean;
  hideCodigo?: boolean;
  hideCliente?: boolean;

  forceTipo?: string;

  loading?: {
    entity?: boolean;
  }

  entity?: IContacto;
  clientes?: { id: number, nombre: string }[];
  //roles?: IUsuarioRol[]
}

class Index extends React.Component<IProps, IState> {
  form : FormService<IContacto>;
  constructor(props:IProps) {
    super(props);
    this.form = Common.form(() => this.getEntity);
  }

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.loadEntities(this.state.id);
    console.log("form-formcomponent", this.form)
    this.props.refService && this.props.refService(this.form);
  }

  static getDerivedStateFromProps = (p: IProps, s?: IState): IState => {
    let res: IState = {};
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.id !== s?.id) res.id = p.id;
    if (p?.hideCodigo !== s?.hideCodigo) res.hideCodigo = p.hideCodigo;
    if (p?.readonly !== s?.readonly) res.readonly = p.readonly;
    if (p?.hideCliente !== s?.hideCliente) res.hideCliente = p.hideCliente;
    if (p?.forceTipo !== s?.forceTipo) res.forceTipo = p.forceTipo;
    return res;
  }

  private loadEntities = (id?: number) => {
    const t = Translate.get("config/contactos/form", this.state.storage?.languaje);
    if (!!this.props.entity) {
      const entity = this.props.entity();
      if (!!entity) {
        this.setState({ entity: this.form.setEntity(entity), loading: { ...this.state.loading, ...{ entity: false } } })
        return;
      }
    }
    if (id) {
      this.setState({ loading: { ...this.state.loading, ...{ entity: true } } }, () => {
        API.entity().contacto().get({ id })
          .then(entity => {
            Alert.reponse(entity);
            if (entity.success) {
              this.setState({ entity: this.form.setEntity(entity.data), loading: { ...this.state.loading, ...{ entity: false } } })
            }
          })
          .catch(e => Alert.error(t("Load.Error"), e));
      });
    }
  }


  private change = (field: string, value: any, error?: string, callback?: () => void) => {
    this.setState({ entity: this.form.setValue(field, value, error) }, callback);
  }

  render() {
    const { loading, readonly, entity } = this.state;
    const t = Translate.get("config/contactos/form", this.state.storage?.languaje);
    return (
      <Loader loading={loading?.entity}>
        <Accordion activeIndex={0}>
          <AccordionTab header={t("infoBasica.header")}>
            <Forms.Input form={this.form} name='tipo' title={t("Col.tipo")} placeholder={t("Col.tipo.Placeholder")} disabled={readonly} value={this.state.forceTipo ?? entity?.tipo} onChange={(v, e) => !this.state.forceTipo && this.change('tipo', v, e)} />
            <Forms.Input form={this.form} name='nombre' title={t("Col.nombre")} placeholder={t("Col.nombre.Placeholder")} disabled={readonly} value={entity?.nombre} onChange={(v, e) => this.change('nombre', v, e)} />
            <Forms.Input form={this.form} name='apellido' title={t("Col.apellido")} placeholder={t("Col.apellido.Placeholder")} disabled={readonly} value={entity?.apellido} onChange={(v, e) => this.change('apellido', v, e)} />
            <Forms.Input form={this.form} name='direccion' title={t("Col.direccion")} placeholder={t("Col.direccion.Placeholder")} disabled={readonly} value={entity?.direccion} onChange={(v, e) => this.change('direccion', v, e)} />
          </AccordionTab>
          <hr />
          <AccordionTab header={t("datosDeContacto.header")}>
              <div className={"row"}>
                <div className={"col-4"}>
                  <Forms.Input form={this.form} name='tipoemail' title={t("Col.tipoemail")} placeholder={t("Col.tipoemail.Placeholder")} disabled={readonly} value={entity?.tipoemail} onChange={(v, e) => this.change('tipoemail', v, e)} />
                </div>
                <div className={"col-8"}>
                  <Forms.Input form={this.form} name='email' title={t("Col.email")} email placeholder={t("Col.email.Placeholder")} disabled={readonly} value={entity?.email} onChange={(v, e) => this.change('email', v, e)} />
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-4"}>
                  <Forms.Input form={this.form} name='tipoemail2' title={t("Col.tipoemail2")} placeholder={t("Col.tipoemail2.Placeholder")} disabled={readonly} value={entity?.tipoemail2} onChange={(v, e) => this.change('tipoemail2', v, e)} />
                </div>
                <div className={"col-8"}>
                  <Forms.Input form={this.form} name='email2' title={t("Col.email2")} email placeholder={t("Col.email2.Placeholder")} disabled={readonly} value={entity?.email2} onChange={(v, e) => this.change('email2', v, e)} />
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-4"}>
                  <Forms.Input form={this.form} name='tipotelefono' title={t("Col.tipotelefono")} placeholder={t("Col.tipotelefono.Placeholder")} disabled={readonly} value={entity?.tipotelefono} onChange={(v, e) => this.change('tipotelefono', v, e)} />
                </div>
                <div className={"col-8"}>
                  <Forms.Input form={this.form} name='telefono' title={t("Col.telefono")} placeholder={t("Col.telefono.Placeholder")} disabled={readonly} value={entity?.telefono} onChange={(v, e) => this.change('telefono', v, e)} />
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-4"}>
                  <Forms.Input form={this.form} name='tipotelefono2' title={t("Col.tipotelefono2")} placeholder={t("Col.tipotelefono2.Placeholder")} disabled={readonly} value={entity?.tipotelefono2} onChange={(v, e) => this.change('tipotelefono2', v, e)} />
                </div>
                <div className={"col-8"}>
                  <Forms.Input form={this.form} name='telefono2' title={t("Col.telefono2")} placeholder={t("Col.telefono2.Placeholder")} disabled={readonly} value={entity?.telefono2} onChange={(v, e) => this.change('telefono2', v, e)} />
                </div>
              </div>
          </AccordionTab>
        </Accordion>
      </Loader>
    );
  }

  /** devuelve la entidad */
  getEntity = (): IResponse<IContacto> => {
    var isValid = this.form.isFormValid();
    if (!isValid) {
      return { success: false, error: (this.form.getStatus().errors ?? [])[0] };
    } else {
      const data = this.form.form.getEntity() as any;
      data.tipo = this.state.forceTipo ?? data.tipo;
      return { success: true, data };
    }
  }
}

export { Index }
export default connect((s:any) => ({ storage:s.main }))(Index);
